import { ReactNode, createContext, useContext, useMemo } from 'react'

type DialogContextState = {
  isOpen: boolean
  onClose: () => void
}

const DialogContext = createContext<DialogContextState | null>(null)

export const DialogProvider = ({
  isOpen,
  onClose,
  children,
}: DialogContextState & { children: ReactNode }) => {
  const value = useMemo(() => {
    return {
      isOpen,
      onClose,
    }
  }, [isOpen, onClose])

  return (
    <DialogContext.Provider value={value}>{children}</DialogContext.Provider>
  )
}

export const useDialogContext = () => {
  const context = useContext(DialogContext)
  if (context === null) {
    throw new Error('useDialogContext must be used within an DialogProvider')
  }
  return context
}
